/* Evan Red: de golf tekent zich één keer als hij helemaal in beeld komt. Zonder JS of bij 'minder beweging' staat hij er gewoon.
   Plus de golf-voortgang onder sliders ([data-erwp]): oranje deel = (scrollLeft + zichtbare breedte) / totale breedte. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-erg]').forEach(function (g) {
      if (g.__erg) return; g.__erg = true;
      var r = g.getBoundingClientRect();
      if (r.bottom < 0) return; /* al voorbij: niet meer verbergen */
      g.setAttribute('data-erg-draw', '');
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-drawn'); }); });
      }, { threshold: 1, rootMargin: '0px 0px -10% 0px' });
      io.observe(g);
    });
  }
  function progress(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-erwp]').forEach(function (w) {
      if (w.__erwp) return;
      var sel = w.getAttribute('data-erwp'); if (!sel) return;
      var sec = w.closest('.shopify-section') || document;
      var sc = null;
      try { sc = sec.querySelector(sel) || document.querySelector(sel); } catch (e) { return; }
      if (!sc) return;
      w.__erwp = true;
      var bar = w.querySelector('.erwp__bar'), tick = false;
      function update() {
        tick = false;
        var max = sc.scrollWidth - sc.clientWidth;
        if (max <= 4) { w.hidden = true; return; }
        w.hidden = false;
        var q = Math.min(1, Math.max(0, (sc.scrollLeft + sc.clientWidth) / sc.scrollWidth));
        bar.style.strokeDashoffset = (1 - q).toFixed(4);
      }
      function req() { if (!tick) { tick = true; requestAnimationFrame(update); } }
      sc.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      if ('ResizeObserver' in window) new ResizeObserver(req).observe(sc);
      update();
    });
  }
  function boot(scope) { init(scope); progress(scope); }
  window.erGolfBoot = boot; /* voor later ingeladen inhoud, zoals de related-products-slider (er-style) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
